import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Router } from 'express';
import { of } from 'rxjs';
import { ShopService } from 'src/app/shared/api/shop.service';
import { StoreService } from 'src/app/shared/services/store.service';

@Component({
    selector: 'app-policy-ditta',
    templateUrl: './page-policy-ditta.component.html',
    styleUrls: ['./page-policy-ditta.component.scss']
})
export class PagePolicyDittaComponent implements OnInit {
    breadcrumbs = [
        {label: 'Home',                 url: '/'},
    ]

    title;
    subtitle;
    text;

    constructor(private shop: ShopService, private route : ActivatedRoute) {
        
    }

    ngOnInit() {
        let policyObs = of(null);
        if (this.route.snapshot.url[0].path == 'politiche-di-reso') {
            policyObs = this.shop.getPolicy(1);
            this.breadcrumbs.push({
                label: 'Politiche di reso',
                url: ''
            });
        }
        else if (this.route.snapshot.url[0].path == 'politiche-di-spedizione') {
            policyObs = this.shop.getPolicy(0);
            this.breadcrumbs.push({
                label: 'Politiche di spedizione',
                url: ''
            });
        }
        else if (this.route.snapshot.url[0].path == 'legale') {
            policyObs = this.shop.getPolicy(2);
            this.breadcrumbs.push({
                label: 'Legale',
                url: ''
            });
        }

        policyObs.subscribe(r => {
            this.title = r['title'];
            this.subtitle = r['subtitle'];
            this.text = r['message'];
            
        });
    }

}
